var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-summary-card" }, [
    _c(
      "div",
      { staticClass: "ai-summary-card__header" },
      [
        _c("CompassObject", { attrs: { object: _vm.icon, size: "small" } }),
        _vm._v(" "),
        _c(
          "h3",
          { staticClass: "ai-summary-card__title typographies/heading/h3" },
          [_vm._v(_vm._s(_vm.titles[_vm.type]))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "ai-summary-card__content typographies-paragraph-medium-regular"
      },
      [_c(_vm.componentToDisplay, { tag: "component" })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }